"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentResult = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../Icon/Icon");
var _payment = require("../assets/icons/payment");
var _Button = require("../Button/Button");
var _PaymentResultModule = _interopRequireDefault(require("./PaymentResult.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PaymentResult = function PaymentResult(_ref) {
  var resultType = _ref.resultType,
    containerId = _ref.containerId;
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentResultModule.default.container
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    classname: _PaymentResultModule.default.icon,
    Icon: _payment.Results[resultType]
  }), /*#__PURE__*/_react.default.createElement("span", null, resultType === 'Success' ? 'თქვენი ტრანზაქცია წარმატებულია' : 'თქვენი ტრანზაქცია წარუმატებელია'), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'success',
    onClick: function onClick() {
      return window.location.reload();
    }
  }, "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0")), document.getElementById(containerId));
};
exports.PaymentResult = PaymentResult;
PaymentResult.propTypes = {
  resultType: _propTypes.default.oneOf(['Success', 'Fail'])
};
PaymentResult.defaultProps = {
  resultType: 'Success'
};